<template>

    <el-container class="exam">
        <el-main>
            <!--个人基本信息-->
            <div class="information">

                <div class="line jf fristLine">
                    <span class="header">账号</span>
                    <el-input class="tab-text" :disabled="true" v-model="userForm.UserName"></el-input>
                </div>
                <div class="line jf">
                    <span class="header">真实姓名</span>
                    <el-input class="tab-text" v-model="userForm.RealName"></el-input>
                </div>
                <div class="line jf">
                    <span class="header">性别</span>
                    <el-radio-group v-model.number="userForm.Sex">
                        <el-radio border size="mini" :label=1>男</el-radio>
                        <el-radio border size="mini" :label=2>女</el-radio>
                    </el-radio-group>
                </div>
                <div class="line jf">
                    <span class="header">手机</span>
                    <el-input class="tab-text" v-model="userForm.Telephone" :disabled="true" placeholder="请填写手机号">
                    </el-input>
                    <el-button type="danger" icon="el-icon-edit" size="mini" circle style="margin-left:10px;"
                        @click="OpenUpdateTel"></el-button>
                </div>
                <div class="line jf">
                    <span class="header">邮箱</span>
                    <el-input class="tab-text" v-model="userForm.Email" placeholder="请填写邮箱"></el-input>
                </div>
                <div class="line jf">
                    <span class="header">地址</span>
                    <el-input class="tab-text" v-model="userForm.Address"></el-input>
                </div>
                <div class="line jf">
                    <span class="header">身份证号</span>
                    <el-input class="tab-text" v-model="userForm.CardId"></el-input>
                </div>
                <div class="line jf">
                    <span class="header">学（工）号</span>
                    <el-input class="tab-text" v-model="userForm.NumberNo"></el-input>
                </div>
                <div class="line jf">
                    <span class="header">备注</span>
                    <el-input class="tab-text" v-model="userForm.DescInfo"></el-input>
                </div>
                <div class="line jf">
                    <span class="header"></span>
                    <div class="saveBtn xy-center" @click="EditUser">保存</div>
                </div>

            </div>
            <!--个人基本信息-->

            <!--更新手机号弹框-->
            <el-dialog title="更换手机号" :visible.sync="telVisible" :destroy-on-close="true" :close-on-click-modal="false"
                @close="CloseDialog" width="500px">

                <div class="dialog-step">
                    <el-steps :active="active" align-center finish-status="success">
                        <el-step title="验证原手机号"></el-step>
                        <el-step title="绑定新手机"></el-step>
                    </el-steps>
                </div>
                <div v-if="firstStep" class="dialog-div jf">
                    <p class="dialog-div-p">原手机号：</p>
                    <div class="oldPhone">
                        <el-input class="dialog-text" v-model="oldTel" placeholder="请输入原手机号..."></el-input>
                    </div>
                </div>
                <div v-if="firstStep" class="dialog-div jf">
                    <p class="dialog-div-p">图形验证码：</p>
                    <div class="jf yzm">
                        <el-input class="dialog-text-code" v-model.number="captcha" placeholder="请填写验证码..."></el-input>
                        <img @click="setVerifyCode" v-if="verifyCode" style="width: 90px;height: 34px;margin-top: 2px" class="ml-10 pointer al-self-start" :src="verifyCode.img"/>
                    </div>
                </div>
                <div v-if="firstStep" class="dialog-div jf">
                    <p class="dialog-div-p">验证码：</p>
                    <div class="jf yzm">
                        <el-input class="dialog-text-code" v-model.number="oldCode" placeholder="请填写验证码..."></el-input>
                        <div class="codeBtn">
                            <el-button v-if="!oldPhoneCutdown" type="primary" class="dialog-codebtn"
                                @click="GetOldTelphoneCode">获取验证码</el-button>
                            <el-button v-else disabled class="dialog-codebtn send">{{oldPhoneCutdownTime}}秒后重发
                            </el-button>
                        </div>
                    </div>
                </div>
                <div v-if="sencendStep" class="dialog-div jf">
                    <p class="dialog-div-p">新手机号：</p>
                    <div class="oldPhone">
                        <el-input class="dialog-text" v-model="newTel" placeholder="请填写新手机号..."></el-input>
                    </div>
                </div>
                <div v-if="sencendStep" class="dialog-div jf">
                    <p class="dialog-div-p">图形验证码：</p>
                    <div class="jf yzm">
                        <el-input class="dialog-text-code" v-model.number="captcha" placeholder="请填写验证码..."></el-input>
                        <img @click="setVerifyCode" v-if="verifyCode" style="width: 90px;height: 34px;margin-top: 2px" class="ml-10 pointer al-self-start" :src="verifyCode.img"/>
                    </div>
                </div>
                <div v-if="sencendStep" class="dialog-div jf">
                    <p class="dialog-div-p">验证码：</p>
                    <div class="jf yzm">
                        <el-input class="dialog-text-code" v-model.number="newCode" placeholder="请填写验证码..."></el-input>
                        <div class="codeBtn">
                            <el-button v-if="!newPhoneCutdown" type="primary" class="dialog-codebtn"
                                @click="GetNewTelphoneCode">获取验证码</el-button>
                            <el-button v-else disabled class="dialog-codebtn send">{{newPhoneCutdownTime}}秒后重发
                            </el-button>
                        </div>
                    </div>
                </div>

                <span slot="footer" class="dialog-footer">
                    <el-button v-if="firstStep" size="mini" @click="CloseDialog">取消</el-button>
                    <el-button v-if="sencendStep" type="success" plain size="mini" icon="el-icon-arrow-left"
                        @click="prev">上一步</el-button>
                    <el-button v-if="firstStep" type="success" plain size="mini" @click="next">下一步<i
                            class="el-icon-arrow-right el-icon--right"></i></el-button>
                    <el-button v-if="sencendStep" type="primary" size="mini" @click="UpdateTelphone">确定更换</el-button>
                </span>
            </el-dialog>
            <!--更新手机号弹框-->

        </el-main>
    </el-container>

</template>

<script>
import {
    UserInfo,
    EditUser,
    UpdateUserOrganLevel,
    UpdateTelphoneSendMsg,
    VerifyOldTelphone,
    BindTelphoneSendMsg,
    BindTelphone, GetBuildVerifyCode
} from "@/api/user";
import {
    GetOrganInfoByKeyword,
    GetOrganLevelInfo
} from "@/api/organ";
import { validatePhoneNumber } from "@/utils";

export default {
    components: {},
    created() {
        this.getUserInfo();
    },
    data() {
        return {
            // 用户表单
            userForm: {
                ID: "",
                UserName: "",
                RealName: "",
                Sex: 1,
                Telephone: "",
                Email: "",
                Address: "",
                CardId: "",
                NumberNo: "",
                DescInfo: "",
                OrganName: "",
                GroupUserId: "",
                UserGroup: null
            },
            // 机构信息
            organData: [],
            // 机构用户组信息
            organLeverData: [],
            organId: "",
            organName: "",
            organLeverId: null,
            organLeverName: "",
            telVisible: false,
            // 步骤条
            active: 1,
            firstStep: true,
            sencendStep: false,
            oldTel: "",
            oldCode: "",
            newTel: "",
            newCode: "",
            captcha: "",
            verifyCode: null,
            oldPhoneCutdown: false,
            oldPhoneCutdownTime: 60,
            newPhoneCutdown: false,
            newPhoneCutdownTime: 60
        }
    },
    methods: {
        async setVerifyCode(){
            try {
                let res = await GetBuildVerifyCode();
                this.verifyCode = res.data.data;
            }catch(err){
                console.error(err)
            }
        },
        // 获取用户信息
        async getUserInfo() {
            const {
                data
            } = await UserInfo();
            if (data.code === 100) {
                this.userForm = {
                    ID: data.data.userId,
                    UserName: data.data.UserName,
                    RealName: data.data.RealName,
                    Sex: data.data.Gender === "1" ? 1 : 2,
                    Telephone: data.data.Tel,
                    Email: data.data.Email,
                    Address: data.data.Address,
                    CardId: data.data.CardId,
                    NumberNo: data.data.NumberNo,
                    DescInfo: data.data.DescInfo,
                    OrganName: data.data.OrganName,
                    UserGroup: data.data.LevelName
                };
            }
        },
        // 根据关键字获取机构信息
        async GetOrganInfo(organName) {
            const {
                data
            } = await GetOrganInfoByKeyword({
                pageSize: 15,
                sortBy: "CreateTime",
                sortOrder: "desc",
                keyWord: organName
            });
            if (data.code === 100) {
                this.organData = data.data
            }
        },
        // 根据机构id获取用户组信息
        async GetOrganLevelInfo(value) {
            try {
                if (value) {
                    let organObj = {};
                    organObj = this.organData.find((item) => {
                        if (item.ID === value) {
                            this.organName = item.Name;
                        }
                    });
                    this.organId = value;
                    const {
                        data
                    } = await GetOrganLevelInfo({
                        organId: value
                    })
                    if (data.code === 100) {
                        this.organLeverData = data.data
                    }
                }
            } catch (err) {}
        },
        // 用户组选择事件
        organLeverChange(value) {
            let organLevelObj = {};
            organLevelObj = this.organLeverData.find((item) => {
                if (item.id === value[0]) {
                    this.organLeverName = item.text;
                }
            });

            this.organLeverId = value[0]
        },
        // 编辑用户
        async EditUser() {
            try {
                const {
                    data
                } = await EditUser(this.userForm);
                if (data.code === 100) {
                    // this.$parent.getUserInfo()
                    this.$emit("updataPersonInfo")
                    this.$message({
                        message: "保存成功！",
                        type: "success"
                    });
                } else {
                    this.$message({
                        message: data.msg,
                        type: "error"
                    })
                }
            } catch (err) {
                this.$message({
                    message: "编辑用户发生异常！",
                    type: "error"
                })
            }
        },
        // 更新用户组织层级
        async UpdateUserOrganLevel() {
            try {
                const {
                    data
                } = await UpdateUserOrganLevel({
                    userId: this.userForm.ID,
                    organId: this.organId,
                    levelId: this.organLeverId
                });
                if (data.code === 100) {
                    this.$message({
                        message: "更新成功！",
                        type: "success"
                    });
                    this.userForm.OrganName = this.organName
                    this.userForm.UserGroup = this.organLeverName
                } else {
                    this.$message({
                        message: data.msg,
                        type: "error"
                    })
                }
            } catch (err) {
                this.$message({
                    message: "发生异常！",
                    type: "error"
                })
            }
        },
        check_mobil(phone) {
            if (!(/^1[3456789]\d{9}$/.test(phone))) {
                return false;
            } else {
                return true;
            }
        },
        // 获取旧手机验证码
        async GetOldTelphoneCode() {
            if (!this.check_mobil(this.oldTel)) {
                return this.$message({
                    type: "error",
                    message: "请输入正确的手机号"
                })
            }
            let userInfo = this.$store.state.userInfo;
            let oldTel = this.oldTel.slice(0,3) + this.oldTel.slice(7);
            let userTel = userInfo.Tel.slice(0,3) + userInfo.Tel.slice(7);
            if (oldTel !== userTel) {
                return this.$message({
                    type: "warning",
                    message: "与原手机号不匹配"
                })
            }

            if(this.captcha === "") {
                return this.$message({
                    type: "error",
                    message: "请填写图形验证码"
                })
            }

            try {
                const {
                    data
                } = await UpdateTelphoneSendMsg({
                    telphone: this.oldTel,
                    captchaId: this.verifyCode.captchaId,
                    captcha: this.captcha,
                });
                if (data.code === 100) {
                    this.$message({
                        message: "验证码发送成功！",
                        type: "success"
                    });
                    this.oldPhoneCutdown = true
                    let timer = setInterval(() => {
                        this.oldPhoneCutdownTime--
                        if (this.oldPhoneCutdownTime === 0) {
                            clearInterval(timer)
                            this.oldPhoneCutdown = false
                            this.oldPhoneCutdownTime = 60
                        }
                    }, 1000);
                } else {
                    this.setVerifyCode();
                    this.$message({
                        message: data.msg,
                        type: "error"
                    })
                }
            } catch (err) {
                this.$message({
                    message: "发生异常！",
                    type: "error"
                })
            }
        },
        // 获取新手机验证码
        async GetNewTelphoneCode() {
            if (!validatePhoneNumber(this.newTel)) return this.$message.error("请输入正确的手机号");
            if(this.captcha === "") {
                return this.$message({
                    type: "error",
                    message: "请填写图形验证码"
                })
            }
            try {
                const {
                    data
                } = await BindTelphoneSendMsg({
                    telphone: this.newTel,
                    captchaId: this.verifyCode.captchaId,
                    captcha: this.captcha,
                });
                if (data.code === 100) {
                    this.$message({
                        message: "验证码发送成功！",
                        type: "success"
                    });
                    this.newPhoneCutdown = true
                    let timer = setInterval(() => {
                        this.newPhoneCutdownTime--
                        if (this.newPhoneCutdownTime === 0) {
                            this.newPhoneCutdown = false
                            this.newPhoneCutdownTime = 60
                            clearInterval(timer)
                        }
                    }, 1000);
                } else {
                    this.$message({
                        message: data.msg,
                        type: "error"
                    })
                }
            } catch (err) {
                this.$message({
                    message: "发生异常！",
                    type: "error"
                })
            }
        },
        // 上一步
        prev() {
            this.firstStep = true
            this.sencendStep = false
            this.active = 1
        },
        // 下一步
        async next() {
            try {
                if (!this.oldTel) {
                    this.$message({
                        message: "请填写手机号！",
                        type: "warn"
                    })
                    return
                }

                if (!this.captcha) {
                    this.$message({
                        message: "请填写图形验证码！",
                        type: "warn"
                    })
                    return
                }

                if (!this.oldCode) {
                    this.$message({
                        message: "请填写验证码！",
                        type: "warn"
                    })
                    return
                }

                const {
                    data
                } = await VerifyOldTelphone({
                    telphone: this.oldTel,
                    code: this.oldCode,
                    captchaId: this.verifyCode.captchaId,
                    captcha: this.captcha,
                });
                if (data.code === 100) {
                    this.firstStep = false
                    this.sencendStep = true
                    this.active = 2;
                    this.captcha = "";
                } else {
                    this.$message({
                        message: "验证失败！",
                        type: "error"
                    })
                }
                this.setVerifyCode();
            } catch (err) {
                this.$message({
                    message: "发生异常！",
                    type: "error"
                })
            }
        },
        // 确认绑定新手机号
        async UpdateTelphone() {
            try {
                if (!this.newTel) {
                    this.$message({
                        message: "请填写手机号！",
                        type: "warn"
                    })
                    return
                }

                if (!this.captcha) {
                    this.$message({
                        message: "请填写图形验证码！",
                        type: "warn"
                    })
                    return
                }

                if (!this.newCode) {
                    this.$message({
                        message: "请填写验证码！",
                        type: "warn"
                    })
                    return
                }

                const {
                    data
                } = await BindTelphone({
                    telphone: this.newTel,
                    code: this.newCode,
                    captchaId: this.verifyCode.captchaId,
                    captcha: this.captcha,
                });
                if (data.code === 100) {
                    this.$message({
                        message: "更新成功！",
                        type: "success"
                    });
                    this.getUserInfo()
                    this.CloseDialog()
                } else {
                    this.$message({
                        message: "绑定失败！",
                        type: "error"
                    })
                }
            } catch (err) {
                this.$message({
                    message: "发生异常！",
                    type: "error"
                })
            }
        },
        CloseDialog() {
            this.telVisible = false
            this.oldTel = ""
            this.oldCode = ""
            this.newTel = ""
            this.newCode = ""
            this.firstStep = true
            this.sencendStep = false
            this.active = 1;
            this.captcha = "";
            this.verifyCode = null;
        },
        OpenUpdateTel() {
            if(this.firstStep) {
                this.setVerifyCode();
            }
            this.telVisible = true
            if (!this.userForm.Telephone) {
                this.firstStep = false
                this.sencendStep = true
                this.active = 2
            }
        }

    }
}

</script>

<style lang="less" scoped>
    .exam {
        width: 100%;
        height: 100%;

        .el-main {
            padding: 0 0 5px 0;
            color: black;
            overflow: auto;

            &::-webkit-scrollbar {
                width: 6px;
            }

            &::-webkit-scrollbar-track {
                border-radius: 6px;
            }

            &::-webkit-scrollbar-thumb {
                border-radius: 6px;
                background: #BAC0CA;
            }
        }

        .tab {
            width: 50px;
            height: 4px;
            background: #256CF4;
            border-radius: 2px;
        }

        .information {
            padding: 0px 30px;
            box-sizing: border-box;

            .line {
                margin-bottom: 30px;

                span {
                    font-size: 16px;
                }

                .header {
                    width: 120px;
                    padding-right: 30px;
                    text-align: right;
                }

                .tab-text {
                    width: 360px;
                }

                .bing-line {
                    width: 100%;
                    border-bottom: 1px solid #E5E8EC;
                }

            }

            .saveBtn {
                width: 70px;
                height: 35px;
                background: #256CF4;
                border-radius: 4px;
                color: white;
                cursor: pointer;
            }

            .fristLine {
                margin-top: 20px;
            }
        }

        ::v-deep .el-dialog__body {
            .send {
                color: white;
                background-color: #BAC0CA;
            }

            .dialog-div {
                margin-top: 20px;
                padding: 10px 20px;
                box-sizing: border-box;

                p {
                    width: 80px;
                }
            }

            .oldPhone {
                width: 300px;
            }

            .yzm {
                width: 300px;

                .dialog-text-code {
                    width: 200px;
                }

                .el-button {
                    width: 90px;
                    margin-left: 10px;
                    padding: 0;
                    height: 38px;
                }
            }

            .dialog-step {
                margin-top: 20px;
            }

        }

    }

</style>
